var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSigpad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "28px",
    viewBox: "0 0 30 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Release-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.296437581
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customer-UI",
    transform: "translate(-79.000000, -2030.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signature",
    transform: "translate(79.000000, 2030.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1210938,15 L19.7071289,15 C17.6651367,15 16.0038867,16.6543418 16.0038867,18.6877124 C16.0039453,20.7210246 17.6651953,22.3752497 19.7070703,22.3752497 C20.7796875,22.3752497 21.6523242,23.2442269 21.6523242,24.312346 C21.6523242,25.3805234 20.7796289,26.249559 19.7070703,26.249559 L0.87890625,26.249559 C0.393515625,26.249559 0,26.6414244 0,27.1247795 C0,27.6081346 0.393515625,28 0.87890625,28 L19.7070703,28 C21.7490039,28 23.4101367,26.3457166 23.4101367,24.312346 C23.4101367,22.2790338 21.7489453,20.6248087 19.7070703,20.6248087 C18.6343945,20.6248087 17.7617578,19.7558314 17.7616992,18.6877124 C17.7616992,17.6195349 18.6343945,16.7504993 19.7071289,16.7504993 L29.1210938,16.750441 C29.6064844,16.750441 30,16.3585756 30,15.8752205 C30,15.3918654 29.6064844,15 29.1210938,15 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86251012,7 L0.190348292,11.8218337 C0.0164832552,12.0501931 -0.0429229283,12.3571128 0.0314174628,12.642487 L2.29149761,21.3110209 L5.45093668,13.0042011 C5.62562833,12.5448417 6.10919907,12.326805 6.53093889,12.5169944 C6.95273382,12.7073039 7.15305059,13.2338208 6.97835893,13.6932402 L3.81891986,22 L11.0452578,17.6109388 C11.2831029,17.4664813 11.4403805,17.203673 11.465675,16.9083362 L12,10.6707344 L3.86251012,7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4301708,2.58782204 L8.65774486,0.0632418348 C8.43167334,-0.0210713827 8.17761202,-0.0210713827 7.9515405,0.0631864748 C7.72546899,0.147499692 7.54578058,0.309095412 7.45215314,0.512598621 L5,5.84010891 L13.477405,9 L15.9294967,3.67276651 C16.1245641,3.24909675 15.9009532,2.76331311 15.4301708,2.58782204 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigpad);
export default __webpack_public_path__ + "static/media/sigpad.582516d01c4f1c96316da843b303a4ef.svg";
export { ForwardRef as ReactComponent };